import type { FilterItem } from "@repo/models";

import type { ISegment } from "../helpers/segmentFilterHook";
import type { BranchFilterItem, MarketFilterItem } from "../models/filterItem";

import { BaseController } from "./baseController";

const controller = "GridFilters";

export class GridFiltersController extends BaseController {
	static Get = BaseController.GetFn(controller);
	static GetFilterItems<T extends FilterItem = FilterItem>(action: string, filters?: ISegment) {
		return GridFiltersController.Get<T[]>(action, filters);
	}
	static getBrands(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetBrandsDyn", filters);
	}

	static getChannels(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetChannelsDyn", filters);
	}

	static getMarketers(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetMarketersDyn", filters);
	}

	static getStates(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetStatesDyn", filters);
	}

	static getAllStates() {
		return GridFiltersController.GetFilterItems<StateFilterItem>("GetAllStatesDyn");
	}

	static getBranches(filters?: ISegment) {
		return GridFiltersController.GetFilterItems<BranchFilterItem>("GetBranchesDyn", filters);
	}

	static getReps(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetRepsDyn", filters);
	}

	static getMachines(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetMachinesDyn", filters);
	}

	static getCompanies(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetCompaniesDyn", filters);
	}

	static getDivisions(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetCompanyDivisionsDyn", filters);
	}

	static getRegions(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetCompanyRegionsDyn", filters);
	}

	static getMarkets(filters?: ISegment) {
		return GridFiltersController.GetFilterItems<MarketFilterItem>("GetCompanyMarketsDyn", filters);
	}

	static getManagementAreas(filters?: ISegment) {
		return GridFiltersController.GetFilterItems<MarketFilterItem>("GetCompanyManagementAreasDyn", filters);
	}

	static getOffices(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetOfficesDyn", filters);
	}

	static getLocationStatuses(filters?: ISegment) {
		return GridFiltersController.GetFilterItems<FilterItem>("GetLocationStatuses", filters);
	}
	static getUsers(assignedOnly?: boolean) {
		return GridFiltersController.Get<FilterItem[]>("GetUsersDyn", { assignedOnly });
	}
}

export interface StateFilterItem extends FilterItem {
	code: string;
}
